import { ShoppingCart } from "@phosphor-icons/react";

export default function Orders() {
  return (
    <div className="space-y-6 min-w-0" data-testid="orders-page">
      <div>
        <div className="eyebrow mb-1">Orders</div>
        <h1 className="font-display font-bold text-3xl lg:text-4xl tracking-tighter text-navy">Order management</h1>
        <p className="text-muted-foreground mt-2 text-sm">Track orders from connected marketplaces in one unified inbox.</p>
      </div>

      <div className="card-base p-12 text-center">
        <div className="w-16 h-16 rounded-full bg-orange/10 flex items-center justify-center mx-auto mb-5">
          <ShoppingCart size={28} weight="duotone" className="text-orange"/>
        </div>
        <h3 className="font-display font-semibold text-xl text-navy mb-2">Coming in Phase 3</h3>
        <p className="text-sm text-muted-foreground max-w-md mx-auto">
          Real-time order ingestion from Shopify, Amazon and Flipkart with unified fulfillment status.
          Architecture ready — awaiting live marketplace credentials.
        </p>
      </div>
    </div>
  );
}
